import { apiClient } from './apiClient';

export interface TeamDto {
  teamKey: string;
  name: string;
  isActive: boolean;
  createdDate: string;
}

export interface TeamOperatorDto {
  teamKey: string;
  operatorId: string;
}

class TeamService {
  async getAll(): Promise<TeamDto[]> {
    const response = await apiClient.get('/api/teams');
    return response.data;
  }

  async create(teamKey: string, name: string): Promise<TeamDto> {
    const response = await apiClient.post('/api/teams', { teamKey, name });
    return response.data;
  }

  async update(teamKey: string, name: string, isActive: boolean): Promise<TeamDto> {
    const response = await apiClient.put(`/api/teams/${encodeURIComponent(teamKey)}`, { name, isActive });
    return response.data;
  }

  async getOperators(teamKey: string): Promise<TeamOperatorDto[]> {
    const response = await apiClient.get(`/api/teams/${encodeURIComponent(teamKey)}/operators`);
    return response.data;
  }

  async addOperator(teamKey: string, operatorId: string): Promise<void> {
    await apiClient.post(`/api/teams/${encodeURIComponent(teamKey)}/operators`, { operatorId });
  }

  // Operator IDs are parsed from audio filenames and routinely contain spaces and punctuation,
  // so the path segment has to be encoded or the DELETE silently addresses a different resource.
  async removeOperator(teamKey: string, operatorId: string): Promise<void> {
    await apiClient.delete(
      `/api/teams/${encodeURIComponent(teamKey)}/operators/${encodeURIComponent(operatorId)}`
    );
  }

  async updateUserTeam(userId: string, tenantId: string, teamKey: string | null): Promise<void> {
    await apiClient.put(
      `/api/tenantconfiguration/users/${encodeURIComponent(userId)}/${encodeURIComponent(tenantId)}/team`,
      { teamKey: teamKey || null }
    );
  }
}

export const teamService = new TeamService();
